import axios from 'axios';

export default function getPetworldJobs(companyUuid) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/company/${companyUuid}/petworld-jobs`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
